import React, { useEffect, useRef, useState } from "react";
import mapBoxGl from "mapbox-gl";
import "./map.css";
import { capitalizeAddress } from "../../utils/helpers";
import API from "../../server";
import { connect } from "react-redux";

const MapBox = (props) => {
  const { placeName = "", config, id = "mapWrapper" } = props;

  const mapContainer = useRef();
  const mapRef = useRef(null);
  const isUnmounted = useRef(false);
  const [showMap, setShowMap] = useState(true);
  const mapboxToken = config?.mapbox_token || "";

  // Indicate unmounted component to prevent unmount warning.
  useEffect(() => {
    return () => {
      isUnmounted.current = true;
    };
  }, []);

  useEffect(() => {
    if (!placeName || !mapboxToken) {
      setShowMap(false);
      return;
    }

    mapBoxGl.accessToken = mapboxToken;

    API.forward_geocoding(placeName, mapboxToken)
      .then((res) => {
        if (isUnmounted.current) {
          return;
        }

        const [point] = Array.isArray(res.data?.features)
          ? res.data.features
          : [];
        if (res.status !== 200 || !point) {
          setShowMap(false);
          return;
        }

        // Setup mapbox settings here.
        const [longitude, latitude] = point.center;
        setShowMap(true);
        const mapBox = new mapBoxGl.Map({
          container: mapContainer.current,
          style: "mapbox://styles/mapbox/streets-v12",
          center: [longitude, latitude],
          zoom: 15,
          scrollZoom: false,
        });

        // Create a default Marker and add it to the map
        new mapBoxGl.Marker({ color: "red" })
          .setLngLat([longitude, latitude])
          .addTo(mapBox);

        const markerHeight = 36;
        const popupOffsets = { bottom: [0, -markerHeight] };

        //create popup to display address info
        new mapBoxGl.Popup({ offset: popupOffsets, closeOnClick: false })
          .setLngLat([longitude, latitude])
          .setHTML(
            `<div class="address-popup-map">${capitalizeAddress(...placeName.split(","))}</div>`,
          )
          .addTo(mapBox);

        mapBox.addControl(
          new mapBoxGl.NavigationControl({
            showCompass: false,
            showZoom: true,
          }),
          "bottom-right",
        );

        mapRef.current = mapBox;
      })
      .catch(() => {
        if (isUnmounted.current) {
          return;
        }
        setShowMap(false);
      });

    // Cleanup function to remove the map instance when the values change.
    return () => {
      mapRef.current?.remove();
      mapRef.current = null;
    };
  }, [placeName, mapboxToken]);

  if (!showMap) {
    return null;
  }

  return <div ref={mapContainer} id={id} />;
};

const mapStateToProps = (state) => {
  return {
    config: state.getIn(["headers", "config"]),
  };
};

const getTimezoneHelper = async (longitude, latitude, token) => {
  return API.search_timezone(longitude, latitude, token).then((point) => {
    if (point.data.features.length > 0) {
      let timezone = point.data.features[0].properties.TZID;
      return timezone;
    }
  });
};

export function getTimezone(placeName, token, callback, callbackFailure) {
  return API.forward_geocoding(placeName, token)
    .then(async (res) => {
      let point = res.status === 200 ? res.data.features[0] : null;
      if (point) {
        let longitude = point.center[0],
          latitude = point.center[1];

        try {
          let result = await getTimezoneHelper(longitude, latitude, token);
          callback(result);
        } catch {
          throw new Error("Error retrieving Mapbox timezone");
        }
      } else {
        throw new Error("Error retrieving Mapbox coordinates");
      }
    })
    .catch((error) => {
      console.error(error);
      if (callbackFailure) {
        callbackFailure();
      }
    });
}

export default connect(mapStateToProps, null)(MapBox);
